<template>
    <div id="index">
        <div class="headerWrap">
            <div style="position:fixed;top:0px;left:5px;line-height: 50px;">
                <span v-for="(item,index) in nav" :key="index">{{index==nav.length-1 ? item : item+' / '}}</span>
            </div>
            <div style="margin:10px 20px" v-if="user">
                <i class="el-icon-s-custom" style="font-color:white;"></i>    
                {{user.title}}
            </div>
            <el-dropdown @command="changeGroup"  v-if="currentGroup">
                
                <span class="header_logout" style="font-size:1.4em;cursor:pointer;" >
                    {{currentGroup.title}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item v-for="(group,index) of groups" :key="index" :icon="group.id == currentGroup.id ?  'el-icon-check' : 'el-icon-more-outline'" :command='index'>{{group.title}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            
            <div  style="margin:10px;cursor:pointer;"> 
                <span  class="header_logout" @click="logout"> Logout </span>
            </div>
            <!-- <div style="margin:10px"> 
                <a href="#" class="header_logout" @click="userInfoFormVisible = true;copyUser();">My Information </a>
            </div> -->
            <div> 
                <a href="#" class="header_logout" @click="changePwd">Change Password </a>
            </div>
            <div style="margin:10px">
                <a href="#" class="header_logout" @click="fetchTestRecords">Notebook </a>
            </div>
        </div>
        <div v-show="textbooks.length > 0">
            <div id="textbooks" :style="{width : width*0.98+'px'}" style="margin-top:60px;margin-bottom: 50px;text-align:center;">
                <el-carousel :autoplay=false type="card" :height="width*0.25+'px'"  indicator-position="none" @change="onTextbookChange" :initial-index="textbookIndex" style="overflow: hidden;">
                    <el-carousel-item v-for="(item,index) in textbooks" :key="index" 
                    style="text-align: center;border: 1px solid white;border-radius: 20px;" 
                    :style="{width:width*0.5+'px',backgroundImage: 'url('+item.cover+')',backgroundSize:width*0.5+'px '+width*0.25+'px'}">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div v-show="levels.length > 0">
            <div id="levels">
                <h1 class="breadCrumb">Content</h1>
                <div style="display: flex;flex-direction: row;align-items: center;justify-content:center;height: 50px;" >
                    <div @click="selectLevel(index)" :style="{width:levelWidth+'px', background : item.isSelected ? 'white' : 'rgba(38, 0, 255, 0.418)',color:item.isSelected?'rgba(38, 0, 255, 0.418)':'white'}" 
                        v-for="(item,index) in levels" :key="index" class="levelItem">
                        {{item.title}}
                    </div>
                </div>
                <div class="bookroomSlider_heading">
                    <hr/>
                </div>
            </div>
        </div>
        <div v-show="units.length > 0">
            <div id="currentUnit" v-if="currentUnit" style="display: flex;flex-direction:row;">
                <h1 class="breadCrumb">Current Unit</h1>
                <div>
                    <img :src="currentUnit.cover" :width="width*0.1+'px'" @click="clickUnit(-1)">
                </div>
                
            </div>
            <div class="bookroomSlider_heading" v-if="currentUnit != null">
                <hr/>
            </div>
            <h1 class="breadCrumb">Units</h1>

            <div id="units" >
                <div style="margin:auto auto;width:90vw;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;">
                    <div id="unit"  v-for="(item,index) in units" :key="index" style="width:15vw; margin:10px;">
                        <el-badge :value="item.idx" class="item">
                            <el-image  fit="contain"  :src="item.cover" lazy @click="clickUnit(index)" >
                                <div slot="placeholder">
                                    <img src="/images/timg.gif" :width="width*0.1+'px'" >
                                </div>
                            </el-image>
                        </el-badge>
                    </div> 
                </div>
            </div>
            <el-dialog title="" :visible.sync="unitModeVisible" style="font-family: chewy,verdana,arial;" v-if="levelAuth">
                <div style="display:flex; flex-direction:row; align-items:center;background: white url(/images/mode/bg.png) repeat fixed top;padding:0px;margin:px;">
                    <div style="width:40%">
                        <img v-if="selectedUnit" :src="selectedUnit.cover" width="100%" style="transform: scale(1.0)"/>
                    </div>
                    <div style="width:60%;margin-left:50px;">
                        <div style="display:flex; flex-direction:row;">
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.tx">
                                <img src="/images/mode/listen.png" :width="width*0.04" @click="clickMode('tx')"/>
                                <h3>播放</h3>
                            </div>
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.lis">
                                <img src="/images/mode/say.png" :width="width*0.04" @click="clickMode('lis')"/>
                                <h3>听力</h3>
                            </div>
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.quiz">
                                <img src="/images/mode/test.png" :width="width*0.04" @click="clickMode('quiz')"/>
                                <h3>测试</h3>
                            </div>
                        </div>
                        <div style="display:flex; flex-direction:row; justify-content:flex-start; align-items:center;" >
                            <img src="/images/mode/book.png" :width="width*0.08" style="transform: scale(1.0)"/>
                            <h1>巩固练习</h1>
                        </div>
                        <div style="display:flex; flex-direction:row;">
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.w1">
                                <img src="/images/mode/1.png" :width="width*0.04" @click="clickMode('w1')" />
                                <h5>看图认读</h5>
                            </div>
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.w2">
                                <img src="/images/mode/2.png" :width="width*0.04" @click="clickMode('w2')"/>
                                <h5>单词拼写</h5>
                            </div>
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.w3">
                                <img src="/images/mode/3.png" :width="width*0.04" @click="clickMode('w3')"/>
                                <h5>听写</h5>
                            </div>
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.w4">
                                <img src="/images/mode/4.png" :width="width*0.04" @click="clickMode('w4')"/>
                                <h5>翻译</h5>
                            </div>
                            <div style="text-align:center; margin : 10px;" v-if="levelAuth.st">
                                <img src="/images/mode/5.png" :width="width*0.04" @click="clickMode('st')"/>
                                <h5>重点句型</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <el-dialog title="Change Password" :visible.sync="editPasswordFormVisible" style="font-family: chewy,verdana,arial;" :close-on-click-modal="false">
            <el-form :model="editPwdForm">
                <el-form-item label="Please enter the old password" label-width="auto">
                <el-input v-model="editPwdForm.oldPwd" autocomplete="off" maxlength=30 show-word-limit show-password></el-input>
                </el-form-item>
                <el-form-item label="Please enter the new password" label-width="auto">
                    <el-input v-model="editPwdForm.newPwd1" autocomplete="off" show-word-limit maxlength="30" show-password></el-input>
                </el-form-item>
                <el-form-item label="Please enter the new password again" label-width="auto">
                    <el-input v-model="editPwdForm.newPwd2" autocomplete="off" maxlength=30 show-word-limit show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEditPwd" style="font-family: chewy,verdana,arial">cancel</el-button>
                <el-button type="primary" @click="confirmEditPwd" style="font-family: chewy,verdana,arial">confirm</el-button>
            </div>
        </el-dialog>
        <el-dialog fullscreen title="My Notebook" :visible.sync="noteFormVisible" style="font-family: chewy,verdana,arial;">
            <el-tabs v-model="notebook.mode" type="card" @tab-click="handleClick">
                <el-tab-pane label="看图认读" name="w1"></el-tab-pane>
                <el-tab-pane label="单词拼写" name="w2"></el-tab-pane>
                <el-tab-pane label="听写" name="w3"></el-tab-pane>
                <el-tab-pane label="翻译" name="w4"></el-tab-pane>
                <el-tab-pane label="重点句型" name="st"></el-tab-pane>
                <el-tab-pane label="Quiz" name="quiz"></el-tab-pane>
            </el-tabs>
            <el-table
                    empty-text="╮(╯▽╰)╭空空如也"
                    stripe
                    :data="notebook.records"
                    style="width: 100%">
                <el-table-column
                        prop="startTime"
                        label="Start Time">
                </el-table-column>
                <el-table-column
                        prop="textbook"
                        label="Textbook">
                </el-table-column>
                <el-table-column
                        prop="level"
                        label="Level">
                </el-table-column>
                <el-table-column
                        prop="unit"
                        label="Unit">
                </el-table-column>
                <el-table-column
                        prop="spendSeconds"
                        label="Time Spent(s)">
                </el-table-column>

                <el-table-column
                        prop="result"
                        label="Accuracy(%)">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.result == 100" type="success">{{scope.row.result}}</el-tag>
                        <el-tag v-else  type="info">{{scope.row.result}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        align="right">
                    <template slot-scope="scope">
                        <el-button
                                v-if="scope.row.result != '100'"
                                size="mini"
                                @click="seeDetail(scope.$index)">detail</el-button>
                        <el-button
                                v-if="notebook.mode == 'quiz' && scope.row.result != '100'"
                                size="mini"
                                type="success"
                                @click="testNotebook(scope.$index)">test again</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div style="text-align: center; margin: 20px;">
                <el-pagination
                        @size-change="onPageSizeChange"
                        @current-change="onCurrentPageIndexChange"
                        background
                        :page-size="notebook.pageSize"
                        :page-sizes="[10,20,40,80]"
                        layout="total, sizes, prev, pager, next"
                        :total="notebook.total">
                </el-pagination>
              <div v-if="notebook.records != undefined && notebook.records.length > 0 && notebook.mode != 'quiz'" style="text-align: right; margin: 20px;">
                <el-button
                    type="success"
                    @click="testNotebook()">test</el-button>
              </div>
            </div>
        </el-dialog>
        <el-dialog title="Personal Information" :visible.sync="userInfoFormVisible" @close="cancelUserInfo" style="font-family: chewy,verdana,arial;">
                <el-switch style="margin-bottom:10px;" v-model="isEditable" active-text="editable" inactive-text="uneditable"></el-switch>
                <el-form :model="tmpUser" label-width="auto">
                  <el-form-item label="name">
                    <el-input v-model="tmpUser.name" autocomplete="off" maxlength=10 :readonly="!isEditable"></el-input>
                  </el-form-item>
                  <el-form-item label="sex" >
                        <el-select v-model="tmpUser.sex" placeholder="请选择" style="width:100%" :disabled="!isEditable">
                                <el-option value="男"  label="男"></el-option>
                                <el-option value="女"  label="女"></el-option>
                        </el-select>
                  </el-form-item>
                  <el-form-item label="birthday">
                        <el-date-picker value-format="yyyy-MM-dd" style="width:100%" v-model="tmpUser.birthday" :disabled="!isEditable"
                        type="date" placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="role">
                        <span v-for="(role,index) in user.roles" :key="index">
                            {{role.name}}
                            <span v-if="index < user.roles.length-1">/</span>
                        </span>
                  </el-form-item>
                <el-form-item label="school">
                    <span v-if="tmpUser.school!=undefined">{{tmpUser.school.name}}</span>
                </el-form-item>
                <el-form-item label="grade">
                        <span v-if="tmpUser.grade!=undefined">{{tmpUser.grade.name}}</span>
                </el-form-item>
                <el-divider content-position="left">contact information</el-divider>
                <el-form-item label="telephone">
                    <el-input type="text" show-word-limit minlength="11" maxlength="11" placeholder="请输入手机号码" :readonly="!isEditable"
                        v-model="tmpUser.phone" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="wechat">
                    <el-input show-word-limit maxlength="30" placeholder="请输入微信" v-model="tmpUser.weChat" clearable :readonly="!isEditable">
                    </el-input>
                </el-form-item>
                <el-form-item label="QQ">
                    <el-input show-word-limit maxlength="15" placeholder="请输入QQ" v-model="tmpUser.qq" clearable :readonly="!isEditable">
                    </el-input>
                </el-form-item>
                   
                </el-form>
                <div slot="footer" class="dialog-footer" :hidden="!isEditable">
                    <el-button @click="cancelUserInfo" style="font-family: chewy,verdana,arial">cancel</el-button>
                    <el-button type="primary" @click="confirmUserInfo" style="font-family: chewy,verdana,arial">confirm</el-button>
                </div>
        </el-dialog>
        <el-drawer
                size="50%"
                :visible.sync="notebook.drawer"
                direction="rtl">
            <el-table
                    stripe
                    :data="notebook.wrongDetails"
                    style="width: 100%">
                <el-table-column
                        prop="title"
                        label="名称">
                </el-table-column>
                <el-table-column
                        prop="answer"
                        label="错误回答">
                </el-table-column>
            </el-table>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name : "index",
    data(){
        return {
            levelAuth : null,
            user : {},
            groups : [],
            currentGroup : null,
            levelWidth : 0,
            width : document.documentElement.clientWidth,
            fullscreenLoading : false,
            textbooks : [],
            levels : [],
            units : [],
            textbookId : -1,
            textbookIndex : -1,
            textbookIndexClickChange : false,
            levelIndex : -1,
            unitIndex : -1,
            levelId : -1,
            unitId : -1,
            lastLevelIndex : -1,
            lastTextbookIndex : -1,
            nav : [],
            editPasswordFormVisible : false,
            userInfoFormVisible : false,
            noteFormVisible : false,
            moniterVisible : false,
            editPwdForm : {
                oldPwd : '',
                newPwd1 : '',
                newPwd2 : ''
            },
            isEditable : false,
            tmpUser : {},
            unitInfo : {total : 0,mine:0},
            notebook : {
                mode: "w1",
                records : [],
                pageSize : 10,
                pageIndex : 1,
                total: 0,
                wrongDetails:[],
                drawer : false
            },
            currentUnit : null,
            textbookPwd : 0,
            levelPwd : 0,
            selectedUnit : null,
            unitModeVisible : false,
            currentCmd : 0
        }
    },
    methods : {
        seeDetail : function(index){
            let _this = this;
            let testId = _this.notebook.records[index].id;
            let type = _this.notebook.mode;
            _this.request("GET","/test/detail/"+testId+"/"+type, null, function(data){
                _this.notebook.wrongDetails = data;
                _this.notebook.drawer = true;
            })
        },
        handleClick(){
            this.fetchTestRecords();
        },
        onPageSizeChange(val){
            this.notebook.pageSize = val;
            this.fetchTestRecords();
        },
        onCurrentPageIndexChange(val){
            this.notebook.pageIndex = val;
            this.fetchTestRecords();
        },
        changePwd(){
            this.editPasswordFormVisible = true;
            this.editPwdForm = {
                oldPwd : '',
                newPwd1 : '',
                newPwd2 : ''
            }
        },
        changeGroup(cmd){
            if(cmd == this.currentCmd){
                return;
            }else{
                this.currentCmd = cmd;
            }
            localStorage.setItem("groupIndex",cmd);
            localStorage.removeItem("textbookIndex");
            localStorage.removeItem("levelIndex");
            this.textbookIndex = -1;
            this.levelIndex = -1;
            this.textbooks = [];
            this.levels = [];
            this.units = [];
            this.currentGroup = this.groups[cmd];
        },
        testNotebook : function(val){
            if(this.notebook.mode == 'quiz'){
              let testId = this.notebook.records[val].id;
              let unit = {title:this.notebook.records[val].unit, id: this.notebook.records[val].unitId};
              let mode = this.notebook.mode;
              this.$router.push({name:'quiz',params:{notebook: true, type: mode, unit: unit, testId: testId}});
            }else{
              let customerUserId = this.user.id;
              let mode = this.notebook.mode;
              let unit = {title:"Notebook Test"}
              this.$router.push({name:'test',params:{unit:unit, notebook: true, type: mode, customerUserId: customerUserId}});
            }
        },
        fetchTestRecords : function(){
            this.noteFormVisible = true;
            let _this = this;
            let qs = "?pageIndex="+this.notebook.pageIndex+"&pageSize="+this.notebook.pageSize;
            qs +="&customerUserId="+this.user.id;
            qs += "&mode="+this.notebook.mode;
            this.request("GET","/test"+qs, null,function(data){
                _this.notebook.records = data.records;
                _this.notebook.total = data.total;
            });
        },
        clickMode : function(type){
            if(type == 'lis'){
                this.$router.push({name : 'listenAudio',params:{unit : this.selectedUnit}});
            }else if(type == 'tx'){
                this.$router.push({name : 'listen',params:{unit : this.selectedUnit}});
            }else if(type == 'quiz'){
                this.$router.push({name : 'quiz',params:{unit : this.selectedUnit}});
            }else {
                this.$router.push({name:'test',params:{type:type,unit:this.selectedUnit}});
            }
        },
        clickUnit : function(index){
            this.unitModeVisible = true;
            if(index >= 0){
                this.selectedUnit = this.units[index];
                this.currentUnit = this.selectedUnit;
            }else{
                this.selectedUnit = this.currentUnit;
            }
            localStorage.setItem("currentUnit",JSON.stringify(this.currentUnit));
        },
        editPwd : function(){
            this.userInfoFormVisible = true;    
            this.copyUser();   
        },
        copyUser : function(){
            let user = this.user;
            this.tmpUser = {
                id : user.id,
                name : user.name,
                sex : user.sex,
                birthday : user.birthday,
                school : {
                    id : user.school.id,
                    name : user.school.name
                },
                grade : {
                    id : user.grade.id,
                    name : user.grade.name
                },
                phone : user.phone,
                weChat : user.weChat,
                qq : user.qq,
                account : user.account,
                password : user.password
            }
            let roles = [];
            for(let i in user.roles){
                roles.push({id:user.roles[i].id,name:user.roles[i].name})
            }
            this.tmpUser.roles = roles;
        },
        updateUser : function(user,callback){
            this.request("PUT","/user/"+user.id,user,function(data){
                callback && callback(data);
            });
        },
        
        confirmUserInfo : function(){
            if(this.isEditable){
                let _this = this;
                this.updateUser(_this.tmpUser,function(){
                    _this.$message("修改成功");
                    _this.user = _this.tmpUser;
                    _this.tmpUser = {};
                    _this.isEditable = false;
                    _this.userInfoFormVisible = false;
                });
            }else{
                this.cancelUserInfo();
            }
        },
        cancelUserInfo : function(){
            this.isEditable = false;
            this.userInfoFormVisible = false;
        },
        
        cancelEditPwd : function(){
            this.editPwdForm.oldPwd="";
            this.editPwdForm.newPwd1="";
            this.editPwdForm.newPwd2="";
            this.editPasswordFormVisible=false;
        },
        confirmEditPwd : function(){
            if(this.editPwdForm.oldPwd.length == 0){
                this.$message("请输入密码");
                return ;
            }
            if(this.editPwdForm.newPwd1.length == 0){
                this.$message("请输入新密码");
                return ;
            }
            if(this.editPwdForm.newPwd2.length == 0){
                this.$message("请再次输入新密码");
                return ;
            }
            if(this.editPwdForm.newPwd1 == this.editPwdForm.newPwd2){
                if(this.editPwdForm.newPwd1.length < 6){
                    this.$message("密码长度需要: >=6");
                    return ;
                }
                if(this.editPwdForm.newPwd1 == this.user.password){
                    this.$message("新密码与旧密码一致");
                    return;
                }
                let _this = this;
                let data = {
                    oldPwd : _this.editPwdForm.oldPwd,
                    newPwd : _this.editPwdForm.newPwd1
                };
                _this.request("PUT","/user/"+this.user.id+"/password", data, function(){
                    _this.$message({type:'success',message:'修改成功，请重新登陆'});
                    _this.editPasswordFormVisible = false;
                        setTimeout(function(){
                        _this.logout();
                    },1500)
                })
            }else{
                this.$message("两次密码输入不一致");
            }
        },
        logout : function(){
            localStorage.removeItem("token");
            localStorage.removeItem("stoken");
            this.$router.replace({name:"login"});
        },
        onTextbookChange : function(val){
            if(this.lastTextbookIndex != val){
                this.levels = [];
                this.units = [];
                this.historyInfo = null;
                this.textbookIndexClickChange = true;
                this.textbookIndex = val;
                this.levelIndex = -1;
                this.lastTextbookIndex = val;
            }
        },
        selectLevel : function(index){
            if(index == localStorage.getItem("levelIndex")){
                return;   
            }
            this.levels[localStorage.getItem("levelIndex")].isSelected = false;
            localStorage.setItem("levelIndex",index);
            this.levelIndex = index;
        },
        fetchTextbooks(){
            
        }
    },
    mounted : function(){
        let _this = this;
        
        _this.request("GET","/customerUser/info",null,function(data){
            _this.user = data;
            let userId = localStorage.getItem("userId");
            if(userId == null){
                localStorage.setItem("userId", _this.user.id);
            }
            _this.request("GET","/customerUser/groups",null,function(data){
                if(data == null || data.length == 0){
                    _this.$alert("未加入任何小组，请联系管理员");
                    return ;
                }
                _this.groups = data;
                if(userId == _this.user.id && localStorage.getItem("groupIndex") != null){
                    _this.currentGroup = data[localStorage.getItem("groupIndex")];
                    _this.currentCmd = localStorage.getItem("groupIndex");
                    if(_this.currentGroup == null){
                        _this.currentGroup = data[0];
                        _this.currentCmd = 0;
                    }
                    _this.currentUnit = JSON.parse(localStorage.getItem("currentUnit"));
                }else{
                    _this.currentGroup = data[0];
                    localStorage.setItem("groupIndex",0);
                    localStorage.setItem("userId", _this.user.id);
                }
                
            });

        });
    },
    watch : {
        currentGroup : function(val){
            if(val == null){
                return ;
            }
            let _this = this;
            _this.request("GET","/customerUserGroup/"+val.id+"/textbooks",null,function(data){
                if(data == null || data.length == 0){
                    _this.$alert("未分配教材，请联系管理员");
                    return ;
                }
                _this.textbooks = data;
                if(localStorage.getItem("textbookIndex")){
                    _this.textbookIndex = parseInt(localStorage.getItem("textbookIndex"));
                }else{
                    _this.textbookIndex = 0;
                }
            });
        },
        textbookIndex : function(val){
            if(val < 0){
                return;
            }
            
            if(val >= this.textbooks.length){
                val = 0;
            }
            localStorage.setItem("textbookIndex",val);
            if(this.textbookIndexClickChange){
                localStorage.removeItem("levelIndex");
            }
            let _this = this;
            let textbookId = _this.textbooks[val].id;
            _this.request("GET","/customerUserGroup/"+_this.currentGroup.id+"/"+textbookId+"/levels",null,function(data){
                if(data == null || data.length == 0){
                    _this.$alert("未分配级别，请联系管理员");
                    return ;
                }
                _this.levels = data;
                _this.nav[0] = _this.textbooks[0].title;
                _this.levelWidth = parseInt(_this.width*0.9/_this.levels.length);
                if(localStorage.getItem("levelIndex")){
                    _this.levelIndex = localStorage.getItem("levelIndex");
                }else{
                    _this.levelIndex = 0;
                }
            });
        },
        levelIndex : function(val){
            if(val  < 0 ){
                return;
            }
            if(val >= this.levels.length){
                val = 0;
            }
            localStorage.setItem("levelIndex",val);
            let _this = this;
            let levelId = _this.levels[val].id;
            _this.request("GET","/customerUserGroup/"+_this.currentGroup.id+"/"+levelId+"/units",null,function(data){
                _this.units = data;
                _this.levels[val].isSelected= true;
                _this.nav[1] = _this.levels[val].title;
            });
            _this.request("GET","/customerUserGroup/"+_this.currentGroup.id+"/level/"+levelId+"/authority",null,function(data){
                if(data.id == undefined){
                    _this.$alert("未分配级别");
                }
                _this.levelAuth = data;
            })
        }
    }
}
</script>

<style>

.headerWrap {
    background: #015182;
    color: #fff;
    font-size: 20px;
    height: 50px;
    font-family: chewy,verdana,arial;
    padding: 0 50px;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 10;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content:flex-end;
}
.header_logout:hover{
    background: #fff;
    color: #c53931;
}
.header_logout {
    background: #c53931;
    color: #fff;
    padding: 5px;
    text-decoration: none;
    display: block;
    -webkit-transition: all .2s;
    transition: all .2s;
    backface-visibility: hidden;
    text-overflow: ellipsis;
}
.breadCrumb {
    color: #fff;
    font-family: chewy,verdana,arial;
    font-size: 40px;
    font-weight: 300;
    margin: 30px 20px;
}
.textbook{
    font-family: chewy;
    font-size: 50px;
    font-weight: 300;
    margin: 30px 20px;
    color: black;
    line-height: 200px;
}
.levelItem{
    font-family: chewy,verdana,arial;
    text-align: center;
    background: rgba(38, 0, 255, 0.418);
    color: #fff;
    font-size: 25px;
    border:1px solid white;
    overflow: hidden;
    cursor: pointer;  
}
.levelItem:hover{
    transform: scale(1.0);
    background: #fff;
    color: rgba(38, 0, 255, 0.418);
    font-size : 40px;
}
.unitTitle{
    text-align: center;
    color: rgb(90, 60, 60);
    margin-bottom: 10px;
}
@font-face {
    font-family: 'Chewy';
    font-style: normal;
    font-weight: 400;
    src: local('Chewy'), url(/fonts/Chewy.woff2) format('woff2'), url(/fonts/Chewy.woff) format('woff');
}
.bookroomSlider_heading {
    margin: 50px 30px;
}
hr {
    border-top: 4px dotted rgba(255,255,255,.5);
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    flex-grow: 1;
}
a:link {color: white; text-decoration:none;}
a:visited {color:white;text-decoration:none;}
a:hover{color:rgba(38, 0, 255, 0.418);text-decoration:none;}
.unitImage:hover{
    border: 3px solid red;
}
.el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 100px;
        margin: 0;
    }

.el-carousel__item:nth-child(2n+1) {
    background-color:white;
}

.el-carousel__item:nth-child(2n) {
        background-color: #d3dce6;
}
.masonry { 
        -moz-column-count:3; /* Firefox */
        -webkit-column-count:3; /* Safari 和 Chrome */
        column-count:6;
        -moz-column-gap: 2em;
        -webkit-column-gap: 2em;
        column-gap: 2em;
        width: 80%;
        margin:2em auto;
}
.unitItem { 
        margin-bottom: 2em;
        -moz-page-break-inside: avoid;
        -webkit-column-break-inside: avoid;
        break-inside: avoid;
        position:relative;
}
div img{  
    cursor: pointer;  
    transition: all 0.6s;  
}  

img{
    border-radius: 9px;
    -webkit-border-radius: 9px;
    -moz-border-radius: 9px;
}

</style>